import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DateModel } from 'src/app/shared/models/date.model';
import { NbInputModule, NbTimepickerModule } from '@nebular/theme';
import { DatepickerComponent } from '../datepicker/datepicker.component';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { DateService } from '../../service/date.service';

@Component({
  selector: 'app-date-timepicker',
  templateUrl: './date-timepicker.component.html',
  styleUrls: ['./date-timepicker.component.scss'],
  imports: [
    NbTimepickerModule,
    DatepickerComponent,
    NbInputModule,
    NbDateFnsDateModule,
    ReactiveFormsModule
  ],
  standalone: true
})
export class DateTimepickerComponent {
  @ViewChild('DatePicker', { static: true }) DatePickerComponent!: DatepickerComponent;
  @Output() selectDateTime = new EventEmitter<DateModel>();
  @Input() step = 5;
  @Input() disableTime = false;

  constructor(private dateService: DateService) {
  }


  timePickerFormControl = new FormControl(new Date());

  selectedDateTime!: DateModel;
  now = new Date();


  resetSelectedDate() {
    this.timePickerFormControl.reset();


  }

  setDateAndTime(date: DateModel) {
    this.DatePickerComponent.setDate(date);
    this.timePickerFormControl.setValue(this.dateService.convertDateModelToDateWithTimezone(date));
    this.selectedDateTime = date;
  }

  /**
   * Receives a DateModel event and updates the selectedDateTime property with its values.
   * If all required date properties are defined, it triggers the onSelectedDateTime event.
   * @param {DateModel} event - The DateModel event containing date and time information.
   * @returns {void}
   */
  receiveDate(event: DateModel): void {
    this.selectedDateTime = { ...this.selectedDateTime, ...event };
    if (this.checkDate()) {
      this.onSelectedDateTime();
    }
  }

  /**
   * Handles the time selection event and updates the selectedDateTime property with the chosen time.
   * If all required date properties are defined, it triggers the onSelectedDateTime event.
   * @param {any} event - The time selection event.
   * @returns {void}
   */
  onPickTime(event: any): void {
    let hour!: number;
    let minute!: number;
    if (event.save) {
      const date: Date = event.time;
      hour = date.getHours();
      minute = date.getMinutes();
    }
    this.selectedDateTime = { ...this.selectedDateTime, hour, minute };
    if (this.checkDate()) {
      this.onSelectedDateTime();
    }
  }

  /**
   * Checks if all required date properties (day, month, year, hour, minute) are defined in selectedDateTime.
   * @returns {boolean} True if all required properties are defined; otherwise, false.
   */
  checkDate(): boolean {
    return (
      this.selectedDateTime.day !== undefined &&
      this.selectedDateTime.month !== undefined &&
      this.selectedDateTime.year !== undefined &&
      this.selectedDateTime.hour !== undefined &&
      this.selectedDateTime.minute !== undefined
    );
  }

  /**
   * Triggers the selectDateTime event with the current selectedDateTime value.
   * @returns {void}
   */
  onSelectedDateTime(): void {
    this.selectDateTime.emit(this.selectedDateTime);
  }
}
